/**
 * mcpbQuickActionsPref — persists the cog "Always-show quick actions" toggle (#16, David 2026-06-23).
 *
 * Mirrors mcpbVideoInfoPref: a global localStorage display preference, read into MCPlaybackView state and
 * threaded down. It controls whether each cell's surfaced action row (Snapshot · Download · Archive ·
 * Export) is ALWAYS visible (true) or only revealed on hover / single-tap (false). Hover/tap reveal is
 * always available regardless of this pref — the toggle only adds the always-visible mode.
 *
 * Default ON (David: always-visible is the default; the bigger desktop already hardcoded it, now uniform
 * across sizes). Global per browser, like mcpbVideoInfo / mcpbAutoSkip — NOT per {serial,user}.
 */
const QUICK_ACTIONS_KEY = 'mcpbQuickActionsAlways';

export const getQuickActionsPref = () => {
  try {
    const v = localStorage.getItem(QUICK_ACTIONS_KEY);
    return v === null ? true : v === '1'; // default ON when unset
  } catch (e) { return true; }
};

export const setQuickActionsPref = (enabled) => {
  const next = !!enabled;
  try { localStorage.setItem(QUICK_ACTIONS_KEY, next ? '1' : '0'); } catch (e) { /* ignore */ }
  return next;
};
